module.exports = __webpack_public_path__ + "static/media/jpg.9d865d91.jpg";